'use client';

import Script from 'next/script';
import { useEffect } from 'react';

const AdrumConfig = () => {

let adrumConfigRef = {};
useEffect(() => {
  // window is accessible here.
  window['adrum-start-time'] = new Date().getTime();
  adrumConfigRef = window['adrum-config'] || (window['adrum-config'] = {});
  setAdrumConfig(adrumConfigRef);
 }, []);

 // Update this config with your apps config.
 const setAdrumConfig = (config: any) => {
  config.appKey = window.globalConfig?.OTHERS?.APPDYNAMIC;
  config.adrumExtUrlHttp = 'http://cdn.appdynamics.com';
  config.adrumExtUrlHttps = 'https://cdn.appdynamics.com';
  config.beaconUrlHttp = 'http://sin-col.eum-appdynamics.com';
  config.beaconUrlHttps = 'https://sin-col.eum-appdynamics.com';
  config.useHTTPSAlways = true;
  config.resTiming = { bufSize: 200, clearResTimingOnBeaconSend: true };
  config.spa = {"spa2":true};
  config.isZonePromise = true;
  config.maxUrlLength = 512;
 };

 return <Script src='//cdn.appdynamics.com/adrum/adrum-23.10.0.4353.js' />;

};

export default AdrumConfig;